import { CustomerTemplate, FieldError, FieldInfo, SignatureInfo } from "../../../src/types";

export interface CardColors {
    background: string;
}

export interface ContentInfo {
    left: number;
    width: number;
    centered: boolean;
}

export type TemplateKeys = 'christmas' | 'birthday' | 'easter'|'marriage'|'grief'|'invitation';

export const colors: Record<TemplateKeys, CardColors> = {
    christmas: {
        background: '#000'
    },
    birthday: {
        background: '#fff'
    },
    easter: {
        background: '#fff'
    },
    marriage: {
        background: '#fff'
    },
    grief: {
        background: '#fff'
    },
    invitation: {
        background: '#fff'
    }
}

export const backgrounds: Record<TemplateKeys, string> = {
    christmas: require('../assets/images/christmas_high.png').default,
    birthday: require('../assets/images/birthday_high.png').default,
    easter: require('../assets/images/easter_high.png').default,
    grief: require('../assets/images/grief_high.png').default,
    invitation: require('../assets/images/invitation_high.png').default,
    marriage: require('../assets/images/marriage_high.png').default
}

export const watermarks: Record<TemplateKeys, string> = {
    christmas: require('../assets/images/watermark_high_white.png').default,
    birthday: require('../assets/images/watermark_high.png').default,
    easter: require('../assets/images/watermark_high.png').default,
    grief: require('../assets/images/watermark_high_white.png').default,
    invitation: require('../assets/images/watermark_high.png').default,
    marriage: require('../assets/images/watermark_high.png').default
}

export const content: Record<TemplateKeys, ContentInfo> = {
    christmas: {
        left: 355,
        width: 370,
        centered: true
    },
    birthday: {
        left: 360,
        width: 370,
        centered: true
    },
    easter: {
        left: 305,
        width: 350,
        centered: true
    },
    marriage: {
        left: 297,
        width: 370,
        centered: true
    },
    grief: {
        left: 300,
        width: 370,
        centered: true
    },
    invitation: {
        left: 297,
        width: 380,
        centered: true
    }
}

export const languages: string[] = [
    'de','en'
];

export const size = {
    width: 595,
    height: 883,
    scale: 1
}

export const signatureInfo: SignatureInfo = {
    maxSignatures: 6,
};

type FieldErrorFn = (value: string) => FieldError | undefined;

export const checkLineCount = (maxLines: number) => (value: string): FieldError | undefined => {
    const lines = value.split('\n');
    if(lines.length > maxLines) {
        return {
            message: 'errors.lines',
            intlData: {
                allowedLines: maxLines,
                usedLines: lines.length
            }
        }
    }
    return;
}

export const combineErrors = (validators: [FieldErrorFn]) => (value: string): FieldError[] => {
    return validators.map<FieldError>(v => v(value) as FieldError)
        .filter(r => r !== undefined);
}

const loremIpsumText = 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. \nAt vero eos et accusam et justo duo dolores et ea rebum.'

export const getContentField = (exampleText = loremIpsumText): FieldInfo => {
    return {
        key: 'content',
        name: {
            en: 'Card content',
            de: 'Karteninhalt'
        },
        languageData: {
            'de': exampleText,
            'en': loremIpsumText
        },
        maxLength: 280,
        isValid: combineErrors([checkLineCount(8)])
    }
}
